
export const mockProducts = [
  {
    id: 'prod-1',
    name: 'Premium Coffee Bundle',
    description: 'Artisanal coffee selection featuring premium Arabica beans from Ghana\'s finest roasters. Includes light, medium, and dark roasts perfect for any coffee lover.',
    price: 150,
    vendor_id: 'vendor-1',
    vendors: {
      name: 'Ghana Coffee Roasters',
      is_verified: true,
      rating: 4.9,
      total_sales: 85
    },
    guarantee_eligible: true,
    min_guarantee_amount: 50,
    max_guarantee_amount: 120,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Premium Arabica beans', 'Light, medium, and dark roasts', 'Locally sourced'],
    discount_percentage: 0,
    category: 'Food & Beverage',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.9,
    rating_count: 85
  },
  {
    id: 'prod-2',
    name: 'Local Spices Collection',
    description: 'Authentic Ghanaian spice collection featuring local favorites. Perfect for traditional and modern cooking, bringing rich flavors to your kitchen.',
    price: 85,
    vendor_id: 'vendor-2',
    vendors: {
      name: 'Spice Market Ghana',
      is_verified: true,
      rating: 4.7,
      total_sales: 120
    },
    guarantee_eligible: true,
    min_guarantee_amount: 30,
    max_guarantee_amount: 70,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Authentic spices', 'Perfect for cooking', 'Rich flavors'],
    discount_percentage: 0,
    category: 'Groceries',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.7,
    rating_count: 120
  },
  {
    id: 'prod-3',
    name: 'Fresh Fruit Box',
    description: 'Seasonal selection of fresh local fruits. Hand-picked and delivered fresh to your door. Perfect for healthy snacking and smoothies.',
    price: 120,
    vendor_id: 'vendor-3',
    vendors: {
      name: 'Fresh Harvest Co',
      is_verified: true,
      rating: 4.8,
      total_sales: 45
    },
    guarantee_eligible: true,
    min_guarantee_amount: 40,
    max_guarantee_amount: 100,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Fresh local fruits', 'Hand-picked', 'Healthy snacking'],
    discount_percentage: 0,
    category: 'Fresh Produce',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.8,
    rating_count: 45
  },
  {
    id: 'prod-4',
    name: 'Premium Tea Set',
    description: 'Luxury tea collection featuring local and imported varieties. Includes herbal, green, and black teas with a beautiful serving set.',
    price: 280,
    vendor_id: 'vendor-4',
    vendors: {
      name: 'Tea House Ghana',
      is_verified: true,
      rating: 4.6,
      total_sales: 65
    },
    guarantee_eligible: true,
    min_guarantee_amount: 100,
    max_guarantee_amount: 250,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Luxury tea collection', 'Includes herbal, green, and black teas', 'Beautiful serving set'],
    discount_percentage: 0,
    category: 'Beverages',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.6,
    rating_count: 65
  },
  {
    id: 'prod-5',
    name: 'Gourmet Snack Box',
    description: 'Curated selection of premium local and imported snacks. Perfect for entertaining or treating yourself to something special.',
    price: 180,
    vendor_id: 'vendor-5',
    vendors: {
      name: 'Gourmet Delights',
      is_verified: true,
      rating: 4.5,
      total_sales: 92
    },
    guarantee_eligible: true,
    min_guarantee_amount: 60,
    max_guarantee_amount: 150,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Curated selection of snacks', 'Perfect for entertaining', 'Premium quality'],
    discount_percentage: 0,
    category: 'Snacks',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.5,
    rating_count: 92
  },
  {
    id: 'prod-6',
    name: 'Kitchen Essentials Kit',
    description: 'Complete set of premium cooking utensils and basic ingredients. Everything you need to start cooking delicious meals at home.',
    price: 580,
    vendor_id: 'vendor-6',
    vendors: {
      name: 'Kitchen Pro Ghana',
      is_verified: true,
      rating: 4.9,
      total_sales: 73
    },
    guarantee_eligible: true,
    min_guarantee_amount: 200,
    max_guarantee_amount: 500,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Complete set of cooking utensils', 'Basic ingredients included', 'Perfect for home cooking'],
    discount_percentage: 0,
    category: 'Kitchen',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.9,
    rating_count: 73
  },
  {
    id: 'prod-7',
    name: 'Organic Vegetable Box',
    description: 'Weekly selection of fresh, organic vegetables from local farms. Seasonal varieties perfect for healthy cooking.',
    price: 95,
    vendor_id: 'vendor-7',
    vendors: {
      name: 'Organic Farms GH',
      is_verified: true,
      rating: 4.7,
      total_sales: 38
    },
    guarantee_eligible: true,
    min_guarantee_amount: 30,
    max_guarantee_amount: 80,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Fresh organic vegetables', 'Seasonal varieties', 'Locally sourced'],
    discount_percentage: 0,
    category: 'Fresh Produce',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.7,
    rating_count: 38
  },
  {
    id: 'prod-8',
    name: 'Premium Chocolate Set',
    description: 'Luxury chocolate collection featuring local Ghanaian cocoa. Includes dark, milk, and white chocolate varieties.',
    price: 150,
    vendor_id: 'vendor-8',
    vendors: {
      name: 'Ghana Chocolate Co',
      is_verified: true,
      rating: 5.0,
      total_sales: 25
    },
    guarantee_eligible: true,
    min_guarantee_amount: 50,
    max_guarantee_amount: 120,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Luxury chocolate collection', 'Includes dark, milk, and white varieties', 'Made with local cocoa'],
    discount_percentage: 0,
    category: 'Sweets',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 5.0,
    rating_count: 25
  },
  {
    id: 'prod-9',
    name: 'Household Essentials Pack',
    description: 'Complete set of premium household items including cleaning supplies and basic necessities.',
    price: 220,
    vendor_id: 'vendor-9',
    vendors: {
      name: 'Home Essentials GH',
      is_verified: true,
      rating: 4.8,
      total_sales: 55
    },
    guarantee_eligible: true,
    min_guarantee_amount: 80,
    max_guarantee_amount: 200,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Complete set of household items', 'Includes cleaning supplies', 'Basic necessities included'],
    discount_percentage: 0,
    category: 'Household',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.8,
    rating_count: 55
  },
  {
    id: 'prod-10',
    name: 'Premium Frozen Food Pack',
    description: 'High-quality frozen meals and ingredients. Perfect for busy professionals and families.',
    price: 180,
    vendor_id: 'vendor-10',
    vendors: {
      name: 'Global Frozen Foods',
      is_verified: true,
      rating: 4.8,
      total_sales: 65
    },
    guarantee_eligible: true,
    min_guarantee_amount: 60,
    max_guarantee_amount: 150,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['High-quality frozen meals', 'Convenient for busy lifestyles', 'Ready to cook'],
    discount_percentage: 0,
    category: 'Frozen Foods',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.8,
    rating_count: 65
  },
  {
    id: 'prod-11',
    name: 'Commercial Delivery Truck',
    description: 'Reliable commercial delivery truck perfect for business operations. Includes warranty and maintenance package.',
    price: 85000,
    vendor_id: 'vendor-11',
    vendors: {
      name: 'International Trucks Ltd',
      is_verified: true,
      rating: 4.9,
      total_sales: 28
    },
    guarantee_eligible: true,
    min_guarantee_amount: 25000,
    max_guarantee_amount: 75000,
    status: 'active',
    images: ['/placeholder.svg'],
    features: ['Reliable delivery truck', 'Includes warranty', 'Perfect for business operations'],
    discount_percentage: 0,
    category: 'Vehicles',
    specifications: {},
    shipping_info: {
      free_shipping: true,
      estimated_days: 2
    },
    stock_quantity: 100,
    rating: 4.9,
    rating_count: 28
  }
];

export const mockVendors = [
  {
    id: 'vendor-1',
    name: 'Ghana Coffee Roasters',
    business_type: 'Food & Beverage',
    rating: 4.9,
    rating_count: 85,
    total_sales: 85,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.8,
    fulfillment_rate: 98,
    featured_products: [
      {
        id: 'prod-1',
        name: 'Premium Coffee Bundle',
        description: 'Artisanal coffee selection featuring premium Arabica beans',
        price: 150,
        vendors: {
          name: 'Ghana Coffee Roasters',
          is_verified: true,
          rating: 4.9
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-2',
    name: 'Spice Market Ghana',
    business_type: 'Groceries',
    rating: 4.7,
    rating_count: 120,
    total_sales: 120,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.5,
    fulfillment_rate: 95,
    featured_products: [
      {
        id: 'prod-2',
        name: 'Local Spices Collection',
        description: 'Authentic Ghanaian spice collection featuring local favorites',
        price: 85,
        vendors: {
          name: 'Spice Market Ghana',
          is_verified: true,
          rating: 4.7
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-3',
    name: 'Fresh Harvest Co',
    business_type: 'Fresh Produce',
    rating: 4.8,
    rating_count: 45,
    total_sales: 45,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.7,
    fulfillment_rate: 96,
    featured_products: [
      {
        id: 'prod-3',
        name: 'Fresh Fruit Box',
        description: 'Seasonal selection of fresh local fruits',
        price: 120,
        vendors: {
          name: 'Fresh Harvest Co',
          is_verified: true,
          rating: 4.8
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-4',
    name: 'Tea House Ghana',
    business_type: 'Beverages',
    rating: 4.6,
    rating_count: 65,
    total_sales: 65,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.4,
    fulfillment_rate: 92,
    featured_products: [
      {
        id: 'prod-4',
        name: 'Premium Tea Set',
        description: 'Luxury tea collection featuring local and imported varieties',
        price: 280,
        vendors: {
          name: 'Tea House Ghana',
          is_verified: true,
          rating: 4.6
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-5',
    name: 'Gourmet Delights',
    business_type: 'Food & Beverage',
    rating: 4.5,
    rating_count: 92,
    total_sales: 92,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.3,
    fulfillment_rate: 94,
    featured_products: [
      {
        id: 'prod-5',
        name: 'Gourmet Snack Box',
        description: 'Curated selection of premium local and imported snacks',
        price: 180,
        vendors: {
          name: 'Gourmet Delights',
          is_verified: true,
          rating: 4.5
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-6',
    name: 'Kitchen Pro Ghana',
    business_type: 'Kitchen & Home',
    rating: 4.9,
    rating_count: 73,
    total_sales: 73,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.8,
    fulfillment_rate: 97,
    featured_products: [
      {
        id: 'prod-6',
        name: 'Kitchen Essentials Kit',
        description: 'Complete set of premium cooking utensils and basic ingredients',
        price: 580,
        vendors: {
          name: 'Kitchen Pro Ghana',
          is_verified: true,
          rating: 4.9
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-7',
    name: 'Organic Farms GH',
    business_type: 'Fresh Produce',
    rating: 4.7,
    rating_count: 38,
    total_sales: 38,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.6,
    fulfillment_rate: 93,
    featured_products: [
      {
        id: 'prod-7',
        name: 'Organic Vegetable Box',
        description: 'Weekly selection of fresh, organic vegetables from local farms',
        price: 95,
        vendors: {
          name: 'Organic Farms GH',
          is_verified: true,
          rating: 4.7
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-8',
    name: 'Ghana Chocolate Co',
    business_type: 'Sweets & Confectionery',
    rating: 5.0,
    rating_count: 25,
    total_sales: 25,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.9,
    fulfillment_rate: 99,
    featured_products: [
      {
        id: 'prod-8',
        name: 'Premium Chocolate Set',
        description: 'Luxury chocolate collection featuring local Ghanaian cocoa',
        price: 150,
        vendors: {
          name: 'Ghana Chocolate Co',
          is_verified: true,
          rating: 5.0
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-9',
    name: 'Home Essentials GH',
    business_type: 'Household',
    rating: 4.8,
    rating_count: 55,
    total_sales: 55,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.5,
    fulfillment_rate: 96,
    featured_products: [
      {
        id: 'prod-9',
        name: 'Household Essentials Pack',
        description: 'Complete set of premium household items',
        price: 220,
        vendors: {
          name: 'Home Essentials GH',
          is_verified: true,
          rating: 4.8
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-10',
    name: 'Global Frozen Foods',
    business_type: 'Food & Beverage',
    rating: 4.8,
    rating_count: 65,
    total_sales: 65,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.6,
    fulfillment_rate: 94,
    featured_products: [
      {
        id: 'prod-10',
        name: 'Premium Frozen Food Pack',
        description: 'High-quality frozen meals and ingredients',
        price: 180,
        vendors: {
          name: 'Global Frozen Foods',
          is_verified: true,
          rating: 4.8
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-11',
    name: 'International Trucks Ltd',
    business_type: 'Automotive',
    rating: 4.9,
    rating_count: 28,
    total_sales: 28,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.7,
    fulfillment_rate: 91,
    featured_products: [
      {
        id: 'prod-11',
        name: 'Commercial Delivery Truck',
        description: 'Reliable commercial delivery truck perfect for business operations',
        price: 85000,
        vendors: {
          name: 'International Trucks Ltd',
          is_verified: true,
          rating: 4.9
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-12',
    name: 'Tech Solutions Ghana',
    business_type: 'Electronics',
    rating: 4.7,
    rating_count: 112,
    total_sales: 112,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.5,
    fulfillment_rate: 93,
    featured_products: [
      {
        id: 'prod-12',
        name: 'Business Laptop Bundle',
        description: 'High-performance laptop with accessories and software',
        price: 3200,
        vendors: {
          name: 'Tech Solutions Ghana',
          is_verified: true,
          rating: 4.7
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-13',
    name: 'Handmade Crafts Ghana',
    business_type: 'Arts & Crafts',
    rating: 4.9,
    rating_count: 42,
    total_sales: 42,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.8,
    fulfillment_rate: 97,
    featured_products: [
      {
        id: 'prod-13',
        name: 'Artisan Craft Collection',
        description: 'Handmade traditional crafts by local artisans',
        price: 250,
        vendors: {
          name: 'Handmade Crafts Ghana',
          is_verified: true,
          rating: 4.9
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-14',
    name: 'Office Supply Hub',
    business_type: 'Office Supplies',
    rating: 4.6,
    rating_count: 87,
    total_sales: 87,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.4,
    fulfillment_rate: 95,
    featured_products: [
      {
        id: 'prod-14',
        name: 'Complete Office Starter Kit',
        description: 'Everything needed to set up a professional office space',
        price: 1200,
        vendors: {
          name: 'Office Supply Hub',
          is_verified: true,
          rating: 4.6
        },
        guarantee_eligible: true
      }
    ]
  },
  {
    id: 'vendor-15',
    name: 'Farm Equipment Co',
    business_type: 'Agriculture',
    rating: 4.8,
    rating_count: 31,
    total_sales: 31,
    is_verified: true,
    status: 'active',
    satisfaction_score: 4.7,
    fulfillment_rate: 92,
    featured_products: [
      {
        id: 'prod-15',
        name: 'Small Farm Equipment Package',
        description: 'Essential tools and equipment for small-scale farming',
        price: 4500,
        vendors: {
          name: 'Farm Equipment Co',
          is_verified: true,
          rating: 4.8
        },
        guarantee_eligible: true
      }
    ]
  }
];
